// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__WWdAN","footer":"ChangeClinic_footer__2rVpK"};